"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "BulkActions" */ './lazyIndex');
});
exports.ProgressBar = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.ProgressBar; });
exports.BulkActionProgressBar = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.BulkActionProgressBar; });
exports.lazySubscribeToBulkActionNotification = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.subscribeToBulkActionNotification; });
exports.lazyOnBulkActionSubmitted = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.onBulkActionSubmitted; });
exports.lazyOnBulkActionFailure = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.onBulkActionFailure; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-bulk-action-store/lib/index.js
// module id = 1720
// module chunks = 62 105 108